import { ExtendableError } from 'ts-error';

export class ApplicationException extends ExtendableError { }
